<template>

    <div>
      <!-- Filters -->
      <ExpensesListFilters />
      <!-- Table Container Card -->
      <BCard no-body>
        <div class="m-2">
          <!-- Table Top -->
          <BRow>

            <!-- Per Page -->
            <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
              <label>{{$t("Entries")}}</label>
              <vSelect v-model="perPage"  :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block ml-50 mr-1" />
            </BCol>

            <!-- Search -->
            <BCol cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <!-- <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" /> -->
                <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
                <BDropdown v-if="user.role=='Superadministrador'" variant="success" right class="mr-1">
                  <template #button-content>
                    <FeatherIcon icon="FileTextIcon" class="mr-50" />
                    <span class="text-nowrap">Exportar</span>
                  </template>
                  <BDropdownItem @click="exportExpenses('XLS', false)">
                      <FeatherIcon icon="FileIcon" />
                      <span class="align-middle ml-50">Gastos XLS</span>
                  </BDropdownItem>
                  <BDropdownItem @click="exportXLSPayments">
                      <FeatherIcon icon="FileIcon" />
                      <span class="align-middle ml-50">Pagos XLS</span>
                  </BDropdownItem>
                  <BDropdownItem @click="exportExpenses('CSV', false)">
                      <FeatherIcon icon="FileIcon" />
                      <span class="align-middle ml-50">Gastos CSV</span>
                  </BDropdownItem>

                  <BDropdownItem @click="exportCSVPayments">
                      <FeatherIcon icon="FileIcon" />
                      <span class="align-middle ml-50">Pagos CSV</span>
                  </BDropdownItem>
                </BDropdown>
                <BButton variant="primary" :to="{ name: 'expenses-add'}"> <span class="text-nowrap">{{$t("Add invoice")}}</span></BButton>
              </div>
            </BCol>
          </BRow>

        </div>

        <BTable ref="refExpenseListTable" :items="fetchExpenses" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc" class="position-relative">

          <!-- Column: Id -->
          <template #cell(id)="data">
            <BLink :to="{ name: 'expenses-view', params: { id: data.item.id }}" class="font-weight-bold">
              <span class="text-nowrap"> {{data.item.name }}</span>
            </BLink>
            <br>
            <small><span><b>{{ data.item.n_expense ? 'Factura' : 'Recibo' }}</b></span></small>
          </template>

          <template #head(paid)>
            <feather-icon icon="TrendingUpIcon" class="mx-auto" />
          </template>

          <!-- Column: Expense Status -->
          <template #cell(paid)="data">
            <div>
              <BAvatar :id="`expense-row-${data.item.id}`" size="32" :variant="`light-${resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).variant}`" >
                <FeatherIcon :icon="resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).icon" />
              </BAvatar>
              <span>{{ resolveExpenseStatusVariantAndIcon(data.item.amount, data.item.total_payments).label }}</span>
            </div>
          </template>

          <!-- Column: Client -->
          <template #cell(customer_billing_full_name)="data">
            <BMedia vertical-align="center">
              <template #aside>
                <BAvatar size="32" :src="data.item.avatar" :text="avatarText(data.item.customer_billing_full_name)" :variant="`light-${resolveClientAvatarVariant(data.item.invoiceStatus)}`"/>
              </template>
              <span class="font-weight-bold d-block text-nowrap"> {{ data.item.customer_billing_full_name }} </span>
              <!-- <small class="text-muted">{{ data.item.student.email }}</small> -->
            </BMedia>
          </template>

          <template #cell(amount)="data">
            <div class="text-center">
              <span><b>{{formatCurrency(data.item.amount)}}</b></span>
              <div class="text-center">
                <BBadge  pill variant="light-warning" v-if="isPartialPaid(data.item.amount, data.item.total_payments).value">{{ (isPartialPaid(data.item.amount, data.item.total_payments).owe).toFixed(2) }}€ pendientes</BBadge>
              </div>
            </div>
          </template>

          <!-- Column: Issued Date -->
          <template #cell(dates)="data">
            <small>
              <span class="text-nowrap"><b>Emisión: </b>{{ formatDate(data.item.emit_date) }}</span><br>
              <span class="text-nowrap"><b>Vencimiento: </b>{{ data.item.payment_date ? formatDate(data.item.payment_date) : '(No definida)' }}</span>
            </small>
           </template>

          <template #cell(payment_method)="data">
            <span class="text-nowrap"> {{ data.item.payment_method.name }} </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">
              <!-- Dropdown -->
              <BDropdown variant="link" toggle-class="p-0" no-caret :right="$store.state.appConfig.isRTL" >

                <template #button-content>
                  <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                </template>
                <BDropdownItem :to="{ name: 'expenses-edit', params: { id: data.item.id } }">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">{{ $t('Edit') }}</span>
                </BDropdownItem>
                <BDropdownItem  @click="deletePopup(data.item.id, 'expenses/deleteExpense', '', data.item.id)"  v-if="ability.can('delete', 'expense')">
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">{{ $t('Delete') }}</span>
                </BDropdownItem>

              </BDropdown>
            </div>
          </template>

        </BTable>
        <div class="mx-2 mb-2">
          <BRow>

            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
              <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }} {{ $t('entries') }}</span>
            </BCol>
            <!-- Pagination -->
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

              <BPagination v-model="currentPage" :total-rows="totalExpenses" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>

            </BCol>

          </BRow>
        </div>
      </BCard>

      <BModal ref="dates_modal" centered hide-footer >
        <p>Introduzca las fechas: </p>
        <BRow class="mt-2">
              <DatepickerValidated vsName="Start date" :vsModel.sync="startDateModal" vsRequired vsRules="required"/>
              <DatepickerValidated vsName="End date" :vsModel.sync="endDateModal" vsRequired vsRules="required" :vsMin="startDateModal"/>
              <BCol>
                <BButton @click="exportExpenses( typeExportSelected, true)" variant="primary">Exportar</BButton>
              </BCol>
        </BRow>
      </BModal>
    </div>

  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BTooltip } from 'bootstrap-vue'
  import { onUnmounted, provide, ref } from '@vue/composition-api'
  import { avatarText } from '@core/utils/filter'
  import useExpensesList from './useExpensesList'
  import expensesModule from '../expensesModule'
  import vSelect from 'vue-select'
  import store from '@/store'
  import ExpensesListFilters from './ExpensesListFilters.vue'
  import axios from '@axios'
  import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
  import popups from '@/hooks/popups';
  import exportUtils from '@/hooks/exportUtils'
  import currency from '@/utils/currency'
  import dateUtils from '@/hooks/dateUtils'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import ability from '@/libs/acl/ability';

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, vSelect, ExpensesListFilters, DatepickerValidated, TextInputValidated },
    setup() {
        const { formatCurrency } = currency()
        const { formatDate } = dateUtils()
        const { fetchExpenses, tableColumns, perPage, currentPage, totalExpenses, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refExpenseListTable, statusFilter, typeFilter, paymentMethodFilter, startDateFilter, endDateFilter, groupFilter,  refetchData, resolveExpenseStatusVariantAndIcon, resolveClientAvatarVariant } = useExpensesList()
        const INVOICE_MODULE = 'expenses'
        const { errorToast, successToast, deletePopup } = popups()
        const paymentMethods = ref(null)
        const typeOptions = [
          { name: 'Recibo', value: "n_ticket" },
          { name: 'Factura', value: "n_expense" },
        ]

        const statusOptions = [
          { name: 'Pagado', value: 1 },
          { name: 'Parcialmente pagado', value: 2 },
          { name: 'No pagado', value: 0 },
        ]
        const groupsOptions=ref(null)

        const user = JSON.parse(localStorage.getItem('userData'))

        // Variables para exportaciones
        const { exportData } = exportUtils()
        const dates_modal = ref('')
        const startDateModal=ref(null)
        const endDateModal=ref(null)
        const typeExportSelected=ref(null)
        const whatToExport=ref(null)
        provide('statusOptions', statusOptions)
        provide('typeOptions', typeOptions)
        provide('paymentMethods', paymentMethods)

        provide('typeFilter', typeFilter)
        provide('statusFilter', statusFilter)
        provide('paymentMethodFilter', paymentMethodFilter)
        provide('startDateFilter', startDateFilter)
        provide('endDateFilter', endDateFilter)
        provide('groupsOptions', groupsOptions)
        provide('groupFilter', groupFilter)



        axios.get('payment-methods').then(response => { paymentMethods.value = response.data })


        const exportCSV = () => {
          startDateModal.value=null
          endDateModal.value=null
          dates_modal.value.show()
          typeExportSelected.value="CSV"
          whatToExport.value="standard"
        }

        const exportCSVPayments = () => {
          startDateModal.value=null
          endDateModal.value=null
          dates_modal.value.show()
          typeExportSelected.value="CSV"
          whatToExport.value="payments"
        }

        const isPartialPaid = function(amount, payments){
            if((payments < 0 && payments > amount) || (payments > 0 && payments < amount)) return {value: true , owe: amount-payments}
            return {value: false}
        }

        const exportXLS=() => {
          startDateModal.value=null
          endDateModal.value=null
          dates_modal.value.show()
          typeExportSelected.value="XLS"
          whatToExport.value="standard"
        }

        const exportXLSPayments=() => {
          startDateModal.value=null
          endDateModal.value=null
          dates_modal.value.show()
          typeExportSelected.value="XLS"
          whatToExport.value="payments"
        }

        

        const exportExpenses = function(fileType, datesSelected){
            if (datesSelected) {
              if (!startDateModal.value) {
                errorToast("Selecciona una fecha de comienzo.")
                return
              }

              if (!endDateModal.value) {
                if (!startDateModal) {
                errorToast("Selecciona una fecha de fin")
                }
            }
            } else {
              whatToExport.value="standard"
            }
            
            let name
            let routeName
            let data
            if (whatToExport.value=="standard") {
              if (fileType=="CSV") {
                name="listado_gastos"
              } else if (fileType=="XLS") {
                name="listado_gastos"
              }
               data = {
                  q: searchQuery.value,
                  status: statusFilter.value,
                  type: typeFilter.value,
                  paymentMethod: paymentMethodFilter.value,
                  group: groupFilter.value,
                  start_date: startDateFilter.value,
                  end_date: endDateFilter.value,
                  file_type: fileType
                }
              
              routeName='expenses/export'
            } else {
              if (fileType=="CSV") {
                if (startDateModal.value && endDateModal.value) {name='listado_pagos_'+startDateModal.value+'_'+endDateModal.value;}
              } else if (fileType=="XLS") {
                if (startDateModal.value && endDateModal.value) {name='listado_pagos_'+startDateModal.value+'_'+endDateModal.value;}
              }
               data = {
                    status: statusFilter.value,
                    type: typeFilter.value,
                    paymentMethod: paymentMethodFilter.value,
                    group: groupFilter.value,
                    start_date: startDateModal.value,
                    end_date: endDateModal.value, 
                    file_type: fileType
                  }
              routeName='expensespayments/export'
            }

            

            if(exportData(routeName, data, name, fileType)) {
                    startDateModal.value = null
                    endDateModal.value = null
                    dates_modal.value.hide()
                    successToast(`${fileType} descargado`)
                }else{
                    errorToast(`No ha sido posible descargar el ${fileType}`)
                }  
        }

        // Get groups
         axios.get('groups').then(response=> {
          groupsOptions.value=response.data.groups
        })

        // Register module
        if (!store.hasModule(INVOICE_MODULE))
            store.registerModule(INVOICE_MODULE, expensesModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(INVOICE_MODULE)) store.unregisterModule(INVOICE_MODULE)
        })

      return {
        exportExpenses,
        fetchExpenses,
        tableColumns,
        perPage,
        currentPage,
        totalExpenses,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refExpenseListTable,
        statusFilter,
        refetchData,
        statusOptions,
        avatarText,
        resolveExpenseStatusVariantAndIcon,
        resolveClientAvatarVariant,
        exportCSV,
        exportXLS, 
        dates_modal,
        startDateModal, 
        endDateModal, 
        typeExportSelected,
        exportXLSPayments,
        exportCSVPayments,
        user,
        formatDate, 
        formatCurrency,
        isPartialPaid,
        deletePopup,
        ability
      }
    },
  }
  </script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  .invoice-filter-select {
    min-width: 190px;

    ::v-deep .vs__selected-options {
      flex-wrap: nowrap;
    }

    ::v-deep .vs__selected {
      width: 100px;
    }
  }
  </style>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>

